export var INTERNAL_MOVEMENT = 'Inventory::Movements::InternalMovement';
export var PURCHASE_MOVEMENT = 'Inventory::Movements::PurchaseMovement';
export var SELLING_MOVEMENT = 'Inventory::Movements::SellingMovement';
export var INCREASE_ADJUSTMENT = 'Inventory::Movements::IncreaseAdjustment';
export var DECREASE_ADJUSTMENT = 'Inventory::Movements::DecreaseAdjustment';
export var isAdjustmentMovement = function (type) {
    return type === INCREASE_ADJUSTMENT || type === DECREASE_ADJUSTMENT;
};
